import styled from "styled-components";
import theme from "./global/theme";

export const Container = styled.div`
  background-size: cover;
  background-image: url(${theme.images.main});
`;

export const Loading = styled.div`
  background-size: cover;
  background-image: url(${theme.images.main});
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center:
  padding-top: 200px;
  color: white;
`;
